/* Month calendar for the required-by date. Every disabled day carries the reason
   it is disabled, from WCDelivery, so nobody is left guessing why a date is out.
   Falls back to leaving the native input alone if the engine has not loaded. */
(function () {
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DOW = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

  function iso(d){ return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  function same(a,b){ return a && b && iso(a)===iso(b); }
  function fmt(d){ return d.toLocaleDateString('en-GB',{weekday:'long',day:'numeric',month:'long'}); }

  function build(root) {
    var input = root.querySelector('[data-wc-date-input]');
    var grid  = root.querySelector('[data-wc-grid]');
    var label = root.querySelector('[data-wc-month]');
    var note  = root.querySelector('[data-wc-note]');
    var prev  = root.querySelector('[data-wc-prev]');
    var next  = root.querySelector('[data-wc-next]');
    if (!input || !grid || !window.WCDelivery) return;

    var earliest = WCDelivery.earliestDate();
    var view = new Date(earliest.getFullYear(), earliest.getMonth(), 1);
    var chosen = input.value ? new Date(input.value + 'T12:00:00') : null;

    var REASON = {
      'blackout':'Jade is closed',
      'bank-holiday':'Bank holiday — no post',
      'no-delivery':'No Sunday delivery',
      'lead-time':'Too soon to bake and post',
      'no-post-day':'Cannot be posted in time',
      'at-capacity':'Fully booked'
    };

    function render() {
      label.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      grid.innerHTML = '';
      DOW.forEach(function (d) {
        var h = document.createElement('span');
        h.className = 'wc-cal__dow'; h.textContent = d; h.setAttribute('aria-hidden','true');
        grid.appendChild(h);
      });
      var first = new Date(view.getFullYear(), view.getMonth(), 1);
      var lead = (first.getDay() + 6) % 7;                    // Monday-first
      for (var i = 0; i < lead; i++) grid.appendChild(document.createElement('span'));
      var days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var day = 1; day <= days; day++) {
        var d = new Date(view.getFullYear(), view.getMonth(), day, 12);
        var reason = WCDelivery.disabledReason(d);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wc-cal__day';
        b.textContent = day;
        b.dataset.date = iso(d);
        if (reason) {
          b.disabled = true;
          b.className += ' is-out';
          b.title = REASON[reason] || 'Not available';
          b.setAttribute('aria-label', day + ' ' + MONTHS[view.getMonth()] + ' — ' + (REASON[reason] || 'not available'));
        } else {
          if (same(d, earliest)) { b.className += ' is-first'; b.title = 'First date we can reach'; }
          if (same(d, chosen))   { b.className += ' is-chosen'; b.setAttribute('aria-pressed','true'); }
          b.addEventListener('click', function () { pick(new Date(this.dataset.date + 'T12:00:00')); });
        }
        grid.appendChild(b);
      }
      var atStart = view.getFullYear() === earliest.getFullYear() && view.getMonth() === earliest.getMonth();
      prev.disabled = atStart;
    }

    // The ticket's Arrives row: short date once chosen, calendar folds away after a pick
    // unless the snippet was rendered inline (the homepage keeps it open beside the form).
    var arrives = root.querySelector('[data-wc-arrives]');
    var panel   = root.querySelector('[data-wc-panel]');
    var toggle  = root.querySelector('[data-wc-toggle]');
    var change  = root.querySelector('.wc-cal__change');
    var collapsible = root.hasAttribute('data-wc-collapsible');
    function short(d){ return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'}); }
    function setOpen(open) {
      if (!panel || !collapsible) return;
      panel.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function pick(d) {
      chosen = d;
      input.value = iso(d);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      note.textContent = 'We’ll post to arrive by ' + fmt(d) + '.';
      note.hidden = false;
      if (arrives) arrives.textContent = short(d);
      var mirror = root.dataset.wcMirror ? document.querySelector(root.dataset.wcMirror) : null;
      if (mirror) mirror.textContent = short(d);
      if (change) change.textContent = 'change';
      setOpen(false);
      render();
    }

    prev.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    next.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    if (toggle && collapsible) toggle.addEventListener('click', function () { setOpen(panel.hidden); });

    root.classList.add('is-ready');
    render();
    if (chosen && arrives) arrives.textContent = short(chosen);
    var hint = root.querySelector('[data-wc-earliest]');
    if (hint) hint.textContent = fmt(earliest);
  }

  function init() { document.querySelectorAll('[data-wc-cal]').forEach(function (r) { if (!r.classList.contains('is-ready')) build(r); }); }
  function boot() { if (window.WCDelivery) init(); else setTimeout(boot, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
